import { IconButton } from '@mui/material';
import React from 'react';
import { EngagementPlanTask } from '@redux/tasks/tasksTypes';
import { TrashIcon } from 'components/Icons';
import { PlanTaskDescriptionString } from 'components/PlanTaskDescriptionString/PlanTaskDescriptionString';
import { TaskTypeIcon } from 'components/TaskTypeIcon';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import style from './TasksListItem.scss';

type Props = {
  task: EngagementPlanTask;
  duration?: number;
  onClick?: (task: EngagementPlanTask) => void;
  onRemove?: () => void;
  showRemoveButton?: boolean;
};

export const TasksListItem: React.FC<Props> = ({ task, duration, onClick, onRemove, showRemoveButton = false }) => {
  const handleContainerClick = (e: React.MouseEvent) => {
    // Don't trigger onClick if the remove button was clicked
    if (showRemoveButton && (e.target as HTMLElement).closest('.removeButton')) {
      return;
    }
    onClick?.(task);
  };

  const handleRemoveClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemove?.();
  };

  return (
    <div className={style.container} onClick={handleContainerClick}>
      <TaskTypeIcon taskType={task.taskType} size={20} className={style.typeIcon} />
      <div className={style.textWrapper}>
        <Text variant="md" weight={500}>
          {task.taskName}
        </Text>
        <PlanTaskDescriptionString task={task} duration={duration} />
      </div>
      {showRemoveButton && (
        <IconButton onClick={handleRemoveClick} className={`${style.removeButton} removeButton`} size="small">
          <TrashIcon width={16} height={16} color={Color.RED_600} />
        </IconButton>
      )}
    </div>
  );
};
